import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

export const encryptId = (id) => {
  const encrypted = CryptoJS.AES.encrypt(id.toString(), SECRET_KEY).toString();

  // URL-safe conversion
  return encrypted
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, ''); // remove trailing '=' padding
};

export const decryptId = (encryptedId) => {
  // Restore original Base64 format
  const base64 = encryptedId
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(encryptedId.length + (4 - encryptedId.length % 4) % 4, '='); // re-add '=' padding if needed

  const bytes = CryptoJS.AES.decrypt(base64, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};
